import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'scitis-widget-axis-range-settings',
    templateUrl: './widget-axis-range-settings.component.html',
    styleUrls: ['./widget-axis-range-settings.component.scss'],
    standalone: false
})
export class WidgetAxisRangeSettingsComponent {
  @Input()
  minY: number = 0;

  @Input()
  maxY: number = 0;

  @Output()
  rangeChanged: EventEmitter<number[]> = new EventEmitter<number[]>();

  isInvalidRange: boolean = false;

  onRangeChange() {
    if (!this.verifyRange()) {
      this.isInvalidRange = true;
    } else {
      this.isInvalidRange = false;
    }
    this.rangeChanged.emit([this.minY, this.maxY]);
  }

  private verifyRange(): boolean {
    if (!this.minY) {
      this.minY = 0;
    }

    if (!this.maxY) {
      this.maxY = 0;
    }

    if (this.minY === 0 && this.maxY === 0) {
      return true;
    }

    return this.minY < this.maxY;
  }
}
